import {Inject, Injectable} from '@angular/core';
import { Metrika } from 'ng-yandex-metrika';

interface WindowWithDatalayer extends  Window {
  dataLayer: any[];
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticService {
  private _yaMetricaId: any = '';

  constructor(
    @Inject('Window') private window: WindowWithDatalayer,
    private yaMetrica: Metrika,
    @Inject('environment') private environment,
  ) {
  }

  public get yaMetricaId(): any {
    return this._yaMetricaId;
  };

  public push(event: string) {
    if (this.window.dataLayer) {
      this.window.dataLayer.push({event});
    }
  }

  public async init() {
    try {
      this._yaMetricaId = await this.yaMetrica?.getClientID(this.environment.yandexMetrikaId);
    } catch(e) {
      this._yaMetricaId = '';
      console.error('catch yaMetricaId' + e)
    }
  }
}
